import clinicalTrialsSmallLogo from '@/assets/clinical-trials-small-logo.svg';
import fdaLogo from '@/assets/fda.png';
import gudidLogo from '@/assets/gudid_small.png';
import openalexLogo from '@/assets/openalex_small.png';
import pubmedLogo from '@/assets/pubmed_small.png';
import { Database } from 'lucide-react';
import type { FC } from 'react';

// Database source ID type (matches backend enum)
export type DatabaseSourceId =
  | 'pubmed'
  | 'openalex'
  | 'access_gudid'
  | 'maude_adverse_events'
  | 'fda_recall'
  | 'clinical_trials'
  | 'fda_510k_submissions'
  | 'premarket_approval'
  | 'unknown';

// Database logo mapping
export const databaseLogos: Record<string, string> = {
  pubmed: pubmedLogo,
  openalex: openalexLogo,
  access_gudid: gudidLogo,
  maude_adverse_events: fdaLogo,
  fda_recall: fdaLogo,
  clinical_trials: clinicalTrialsSmallLogo,
  fda_510k_submissions: fdaLogo,
  premarket_approval: fdaLogo,
};

// Get human-readable display name for a database source
export const getDatabaseSourceDisplayName = (
  sourceId: string | null | undefined
): string | null => {
  if (!sourceId) return null;

  const displayNames: Record<string, string> = {
    pubmed: 'PubMed',
    openalex: 'OpenAlex',
    access_gudid: 'AccessGUDID',
    maude_adverse_events: 'FDA MAUDE',
    fda_recall: 'FDA Recall',
    clinical_trials: 'Clinical Trials',
    fda_510k_submissions: 'FDA 510(k)',
    premarket_approval: 'FDA PMA',
  };

  return displayNames[sourceId.toLowerCase()] ?? null;
};

// Database icon component that renders logo or fallback
export interface DatabaseIconProps {
  sourceId: string;
  className?: string;
  fallbackClassName?: string;
}

export const DatabaseIcon: FC<DatabaseIconProps> = ({
  sourceId,
  className = 'h-7',
  fallbackClassName = 'w-4 h-4 text-neutral-600',
}) => {
  const logoSrc = databaseLogos[sourceId.toLowerCase()];

  if (!logoSrc) {
    // Fallback for databases without logos
    return (
      <div className="w-6 h-6 bg-neutral-100 rounded flex items-center justify-center">
        <Database className={fallbackClassName} />
      </div>
    );
  }

  return <img src={logoSrc} alt={`${sourceId} Logo`} className={className} />;
};
